import BailleurProfileCard from "./BailleurProfileCard";
import type { Profile } from "./types";
import Title from "../UI/Title";
import styles from "./BailleurProfileList.module.css";

interface BailleurProfileListProps {
  profiles?: Profile[];
  onEditProfile?: ((profile: Profile, index: number) => void) | null;
  title?: string;
}

export default function BailleurProfileList({
  profiles,
  onEditProfile,
  title = "Informations personnelles",
}: BailleurProfileListProps) {
  if (!profiles || profiles.length === 0) return null;

  return (
    <div className={styles.container}>
      <Title variant="deca" weight="bold" as="h2">
        {title}
      </Title>
      <div className={styles.grid}>
        {profiles.map((profile, index) => (
          <BailleurProfileCard
            key={index}
            profile={profile}
            onEdit={onEditProfile ? () => onEditProfile(profile, index) : null}
          />
        ))}
      </div>
    </div>
  );
}
